export enum DocumentStatus {
    PENDING = 'Pending',
    APPROVED = 'Approved',
    DECLINED = 'Declined',
    CANCELLED = 'Cancelled',
    IN_REVIEW = 'In Review',
    AWAITING_EXEC_APPROVAL = 'Awaiting executive approval',
    AWAITING_FINANCE_APPROVAL = "Awaiting finance approval",
    AWAITING_FUND_DISTRIBUTION = "Awaiting fund distribution",
    AWAITING_STUDENT_RESPONSE = "Awaiting student response",
    CHANGES_REQUESTED = 'Changes requested',
    INVOICE = 'Invoice',
    PAYMENT = 'Payment',
    CONTRACT= 'Contract',
    DISABLE = 'Disabled',
    ENABLE = 'Active',
    APPLICATION_ACTIVE = 'Active',
    DELETE = 'Delete',
    UPDATE = 'Update',
    AMEND = 'Amend',
    PENDING_RENEWAL = "Pending renewal",
    INVALID = 'Invalid',
    REJECTED = 'Rejected',
    ONBOARDED = 'Onboarded',
    TERMINATED = 'Terminated',
    DISTRIBUTE_FUNDS = "Distribute funds"
}
